import { type InferResponseType, unwrap } from "@nexxt/api-client";
import type { ListEmailSuppressionsInput } from "@nexxt/contracts/notifications";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the addresses no email is sent to (ADR-087 point 7, ADR-149 point 8): the latest added first, by
// cursor, searched by part of the address.

const suppressions = api.notifications.suppressions;

type ListPage = InferResponseType<typeof suppressions.$get, 200>;
export type EmailSuppression = ListPage["items"][number];

export type SuppressionFilters = Pick<ListEmailSuppressionsInput, "q">;

const keys = { all: ["email-suppressions"] as const };

export const suppressionQueries = {
  ...keys,

  list: ({ q }: SuppressionFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", { q }],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          suppressions.$get(
            { query: { ...(q && { q }), ...(pageParam && { cursor: pageParam }), limit: "50" } },
            { init: { signal } },
          ),
        ),
      initialPageParam: "",
      getNextPageParam: (last) => last.nextCursor ?? undefined,
    }),
};
